<div class="mb-27 mct-flex mct-row mct-justify-between mct-items-center">
  <span class="title-header">{{ 'profiles.tasks.header' | translate | titlecase }}</span>
  <div class="mct-flex mct-row mct-gap-10" *ngIf="profileTasksTabFullAccess">
    <button [hidden]="!hasProjects" class="mct-flex atlas-btn atlas-btn-primary mct-justify-center mct-items-center" type="button" (click)="taskGenerate.open()">
      <span>{{ 'profiles.tasks.generate-template-tasks' | translate | uppercase }}</span>
    </button>
    <button pButton type="button" class="mct-flex atlas-btn atlas-btn-primary mct-justify-center mct-items-center" type="button" (click)="taskEdit.open()">
      <i class="large-icon pi pi-plus"></i>
      <span>{{ 'profiles.tasks.add-a-task' | translate | uppercase }}</span>
    </button>
  </div>
</div>

<wl-task-edit-dialog #taskEdit></wl-task-edit-dialog>

<wl-task-generate-dialog #taskGenerate></wl-task-generate-dialog>

<div class="params-container mb-20">
  <div class="search-header mb-32">{{ 'profiles.tasks.search-tasks' | translate | titlecase }}</div>
  <wl-task-search-params [(searchParams)]="searchParams"></wl-task-search-params>
  <div class="mt-33 mct-flex mct-row mct-justify-end mct-items-center">
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="searchGrid.search()">
      {{ 'profiles.tasks.run-this-search' | translate | uppercase }}
    </button>
  </div>
</div>

<div class="divider-bar mb-21 mct-flex mct-row mct-justify-end mct-items-center">
  <span *ngIf="!tasksSearchResult?.TotalCount; else resultsReturned" class="no-results">
    {{ 'profiles.tasks.no-search-results' | translate | ucfirst }}
  </span>
  <ng-template #resultsReturned>
    <span>{{ 'profiles.tasks.the-search-returned' | translate | ucfirst }}</span>
    &nbsp;
    <span class="f-wb">{{ tasksSearchResult.TotalCount }}</span>
    &nbsp;
    <span class="f-wb">{{ 'profiles.tasks.tasks' | translate }}</span>
  </ng-template>
  <button type="button" class="mct-flex ml-10 atlas-btn atlas-btn-secondary mct-justify-center mct-items-center" type="button" (click)="clear()">
    <i class="large-icon pi pi-times"></i>
    <span>{{ 'profiles.tasks.clear-search' | translate | uppercase }}</span>
  </button>
</div>

<wl-task-search-grid #searchGrid [searchParams]="searchParams" (completedSearch)="tasksSearchResult = $event"></wl-task-search-grid>
